export default "__VITE_ASSET__BlROI5Oi__"